import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Mail, Phone, MapPin, Send, CheckCircle, AlertCircle } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
import { mockData } from '../mock';

const ContactSection = () => {
  // CRA/CRACO ⇒ variables d'env prefix REACT_APP_
  const formspreeId = process.env.REACT_APP_FORMSPREE_ID || "mldpwrqy" ;

  // On passe un ID "inerte" au hook pour ne pas violer la règle des hooks,
  // puis on bloque la soumission si l'ID est absent.
  const [state, handleSubmit] = useForm(formspreeId);

  const contactInfo = [
    { icon: Mail,  title: 'Email',     value: mockData.contact.email,  link: `mailto:${mockData.contact.email}` },
    { icon: Phone, title: 'Téléphone', value: mockData.contact.phone,  link: `tel:${mockData.contact.phone}` },
    { icon: MapPin,title: 'Adresse',   value: mockData.contact.address,link: null }
  ];

  const onSubmit = (e) => {
    if (!formspreeId) {
      e.preventDefault();
      alert("Configuration manquante : REACT_APP_FORMSPREE_ID n'est pas défini au build.");
      return;
    }
    handleSubmit(e);
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-slate-100 relative overflow-hidden">
     

      <div className="container mx-auto px-4 relative z-10">
   
        {!formspreeId && (
          <div className="mb-6 p-4 rounded-lg border border-yellow-200 bg-yellow-50 text-yellow-800">
            <strong>Configuration Formspree manquante :</strong> définis <code>REACT_APP_FORMSPREE_ID</code> au moment du build.
          </div>
        )}

    
        <Card className="bg-white shadow-2xl border-0">
          <CardHeader>
            <CardTitle className="text-2xl text-gray-900">Envoyez-nous un message</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={onSubmit} className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="name">Nom complet *</Label>
                  <Input id="name" name="name" type="text" required placeholder="Votre nom" />
                  <ValidationError prefix="Name" field="name" errors={state.errors} />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email *</Label>
                  <Input id="email" name="email" type="email" required placeholder="vous@email.com" />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="phone">Téléphone</Label>
                <Input id="phone" name="phone" type="tel" placeholder="+33 1 23 45 67 89" />
              </div>

              <div className="space-y-2">
                <Label htmlFor="message">Message *</Label>
                <Textarea id="message" name="message" rows={6} required placeholder="Votre message..." className="resize-none" />
                <ValidationError prefix="Message" field="message" errors={state.errors} />
              </div>

         
              <input type="text" name="_gotcha" style={{ display: 'none' }} />

           
              <label className="flex items-start space-x-2 text-sm text-gray-600">
                <input type="checkbox" name="consent" required className="mt-1" />
                <span>J’accepte que GoodBloom me contacte par email au sujet de ma demande.</span>
              </label>

          
              {state.succeeded && (
                <div className="p-4 rounded-lg flex items-center space-x-3 bg-green-50 text-green-800 border border-green-200">
                  <CheckCircle className="w-5 h-5" />
                  <span className="text-sm font-medium">Merci ! Votre message a bien été envoyé.</span>
                </div>
              )}
              {state.errors?.length > 0 && (
                <div className="p-4 rounded-lg flex items-center space-x-3 bg-red-50 text-red-800 border border-red-200">
                  <AlertCircle className="w-5 h-5" />
                  <span className="text-sm font-medium">Une erreur s'est produite. Veuillez réessayer.</span>
                </div>
              )}

              <Button
                type="submit"
                disabled={state.submitting}
                className="w-full bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white py-3 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg group text-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              >
                {state.submitting ? 'Envoi en cours...' : <>Envoyer le message <Send className="ml-2 w-5 h-5" /></>}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactSection;